export const ONBOARDING_ROUTE = '/onboarding';
export const DASHBOARD_ROUTE = '/dashboard';
export const TRANSACTIONS_ROUTE = '/transactions';
export const BOOKINGS_ROUTE = '/bookings';
export const REDIRECT_FROM_AUTH_SERVER_ROUTE = '/redirect';
export const OVERVIEW_ROUTE = '/overview';
export const LANDING_ROUTE = '/';
